<template>
  <div class="collection">
    <div class="charli" style="padding-bottom:20px;">
      <div class="h2">案款信息</div>
      <div class="smli">
        <div class="litp">
          <div class="span">
            <label>已履行金额：</label>
            <span>{{ payee.payeeSum | showYuan }}元</span>
          </div>
          <div class="span">
            <label>最新履行日：</label>
            <span>{{ payee.newPayeeTime | yearFormat }}</span>
          </div>
        </div>
        <div class="mainbox">
          <div class="cell">
            <div class="span" v-for='(k, inde) in pxlist(payee.payeeGroupList)' :key="inde">{{ k.type_title }}：{{ k.fee | showYuan }}元
            </div>
          </div>
        </div>
      </div>
      <div class="smli">
        <div class="h3">
          案款记录
        </div>
        <div class="tablelist">
          <table class="table">
            <thead>
              <td>案款日期</td>
              <td>案款小计</td>
              <td>本金</td>
              <td>利息</td>
              <td>诉讼费</td>
              <td>保全费</td>
              <td>公告费</td>
              <td>上诉费</td>
              <td>律师费</td>
              <td>差旅费</td>
              <!-- <td>执行费</td> -->
              <td>评估费</td>
              <td>其他</td>
              <td>银行结清款</td>
            </thead>
            <tbody>
              <tr v-for='(i, index) in list' :class="{ 'isover': i.cancel == 1 }">
                <td>
                  <span v-if="i.time">{{ i.time.slice(0, 10) }}</span>
                </td>
                <td>{{ i.fee | showYuan }}</td>
                <td>{{ rNumVal(i.fee_list, 8) | showYuan }}</td>
                <td>{{ rNumVal(i.fee_list, 9) | showYuan }}</td>
                <td>{{ rNumVal(i.fee_list, 1) | showYuan }}</td>
                <td>{{ rNumVal(i.fee_list, 3) | showYuan }}</td>
                <td>{{ rNumVal(i.fee_list, 2) | showYuan }}</td>
                <td>{{ rNumVal(i.fee_list, 10) | showYuan }}</td>
                <td>{{ rNumVal(i.fee_list, 4) | showYuan }}</td>
                <td>{{ rNumVal(i.fee_list, 5) | showYuan }}</td>
                <!-- <td>{{ rNumVal(i.fee_list, 12) | showYuan }}</td> -->
                <td>{{ rNumVal(i.fee_list, 13) | showYuan }}</td>
                <td>{{ rNumVal(i.fee_list, 7) | showYuan }}</td>
                <td>{{ rNumVal(i.fee_list, 11) | showYuan }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td><b>总计</b></td>
                <td v-for="i in collAll">{{ i | showYuan }}</td>
                <td>-</td>
              </tr>
            </tfoot>
          </table>
          <div class="pages">
            <a-pagination v-model="smform.page" show-quick-jumper :total="total" show-less-items :pageSize='5'
              @change='turnpage' :show-total="total => `小计 ${total} `" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Propo from '@/page/payback/step.json'
const Proposition = [...Propo, {
  "tit": "银行结清款",
  "type": "11"
}]
export default {
  props: {
    payee: Object
  },
  data() {
    return {
      collAll: [],
      smform: {
        page: 1
      }
    }
  },
  computed: {
    list() {
      const allList = this.payee.payeeList || []
      let arr = [], brr = []
      allList.map(ele => {
        if (ele.cancel == 0) {
          arr.push(ele)
        } else {
          return slist.filter((ele, index) => { return index >= (this.smform.page - 1) * 5 && index < this.smform.page * 5 })
        }
      })
    },
    total() {
      if (!this.payee || !this.payee.payeeList) return 0
      return this.payee.payeeList.length
    }
  },
  created() {
    this.getCollList()
  },
  methods: {
    turnpage(val) {
      this.smform.page = val;
    },
    rNumVal(fee_list, t) {
      if (fee_list) {
        let fee = fee_list.filter(ele => { return ele.type == t })
        if (fee.length > 0) {
          return fee[0].fee
        } else {
          return 0
        }
      }
    },
    getCollList() {   //计算合计
      const list = this.payee.payeeList || []
      const getAll = (type) => {
        let i = 0;
        list.forEach(ele => {
          if (ele.cancel === 0) {
            // 内层fee_list也做兜底
            const feeList = ele.fee_list || []
            feeList.forEach(s => {
              if (s.type === type) {
                i += Number(s.fee) || 0; // 转数字防止字符串相加
              }
            })
          }
        })
        return i
      }
    
      const getFee = () => {
        let i = 0;
        list.forEach(ele => {
          if (ele.cancel === 0) {
            i += Number(ele.fee) || 0;
          }
        })
        return i
      }
    
      let all = [8, 9, 1, 3, 2, 10, 4, 5, 13, 7].map(ele => getAll(ele))
      all.unshift(getFee())
      this.collAll = all
    },
    pxlist(Arr, s) {
      let newArr = []
      if (Arr) {
        Proposition.map(ele => {
          let s = Arr.find(s => { return s.type == ele.type })
          if (ele.type != 6) {
            newArr.push({
              type_title: ele.tit,
              type: ele.type,
              fee: s ? s.fee : 0
            })
          }
        })
        return newArr
      }
    },
  }
}
</script>
<style lang="less" scoped>
.h2 {
  line-height: 62px;
  font-size: 1rem;
  font-weight: bold;
  padding: 0 20px;
  color: #0e2949;
  border-bottom: 1px solid #efefef;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.h3 {
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  color: #0e2949;
}

.smli {
  margin-top: 10px;
  padding: 0 20px;

  .litp {
    line-height: 40px;
    display: flex;

    .span {
      width: 224px;
      font-size: 0.875rem;
      color: #0e2949;

      span {
        font-weight: 500;
        color: #0e2949;
      }
    }
  }

  .mainbox {
    width: 100%;
    height: 90px;
    background: #f6f8fc;
    padding: 20px 0 0 20px;

    .cell {
      display: flex;
      width: 1200px;
      display: flex;
      flex-wrap: wrap;

      .span {
        width: 200px;
        margin-bottom: 10px;
        font-size: 0.875rem;
        color: #0e2949;
        line-height: 20px;
      }
    }
  }
}
</style>